// Wait for crypto polyfill if needed (loaded in index.html for insecure contexts)
async function ensureCryptoAvailable() {
  if (typeof window !== 'undefined' && (!window.crypto || !window.crypto.subtle)) {
    // Wait up to 1 second for polyfill to load
    for (let i = 0; i < 10 && (!window.crypto || !window.crypto.subtle); i++) {
      await new Promise(resolve => setTimeout(resolve, 100));
    }
    if (!window.crypto || !window.crypto.subtle) {
      console.warn('Crypto.subtle still not available after waiting for polyfill');
    } else {
      console.log('Crypto.subtle is now available');
    }
  }
}

// Wait for crypto before importing anything that uses Keycloak
await ensureCryptoAvailable();

import { config } from '@fortawesome/fontawesome-svg-core';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

config.autoAddCss = false;
import { Provider } from 'react-redux';
import { store } from './store';
import { AuthProvider } from './auth/AuthProvider';
import { ErrorBoundary } from './components/common/ErrorBoundary';
import { ThemeProvider } from './theme/ThemeProvider';
import { LanguageProvider } from './i18n/LanguageProvider';
import App from './App.tsx';
import './index.css';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

// Add console log to verify this file is loading
console.log('main.tsx is loading...');

try {
  createRoot(rootElement).render(
    <StrictMode>
      <ErrorBoundary>
        <ThemeProvider>
          <LanguageProvider>
            <Provider store={store}>
              <AuthProvider>
                <App />
              </AuthProvider>
            </Provider>
          </LanguageProvider>
        </ThemeProvider>
      </ErrorBoundary>
    </StrictMode>
  );
  console.log('React app rendered successfully');
} catch (error) {
  console.error('Error rendering app:', error);
  rootElement.innerHTML = `
    <div style="padding: 2rem; font-family: Arial, sans-serif;">
      <h1 style="color: #dc2626;">Error Loading App</h1>
      <p>Error: ${error instanceof Error ? error.message : String(error)}</p>
      <p>Check the browser console for more details.</p>
    </div>
  `;
}
